import { render, staticRenderFns } from "./btActRule.vue?vue&type=template&id=21cafdd2"
import script from "./btActRule.vue?vue&type=script&lang=js"
export * from "./btActRule.vue?vue&type=script&lang=js"
import style0 from "./btActRule.vue?vue&type=style&index=0&id=21cafdd2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports